import styled from "@emotion/styled";

interface StatusWrapperProps {
  $color: string;
  $style?: React.CSSProperties;
}

export const StatusWrapper = styled('span')<StatusWrapperProps>(
  ({ $color, $style }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px',
    padding: '4px 8px',
    fontSize: '12px',
    fontWeight: 900,
    backgroundColor: `${$color}20`,
    color: $color,
    cursor: 'pointer',
    ...$style,
  }),
);
